/*
 * Copyright 2026 Bytefinger Technology (HK) Co., Limited (https://bytefinger.ai)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { BrandConfig } from './types';

export const bfaiConfig: BrandConfig = {
  name: 'bfai',
  displayName: 'BFAI ADP',
  title: 'BFAI ADP',
  loginWelcome: 'Welcome to BFAI ADP',
  adminTitle: 'BFAI ADP 管理后台',
  adminLogoText: 'BFAI ADP',
  logos: {
    menuLogo: '/brand/logos/icon-menu-logo.svg',
    brandLogoEnBlack: '/brand/logos/brand-en-black-row.svg',
    brandLogoCnBlack: '/brand/logos/brand-cn-black-row.svg',
    brandLogoCnWhite: '/brand/logos/brand-cn-white-row.svg',
    faviconBase: '/brand/logos/favicon-base.png',
    faviconAddon: '/brand/logos/favicon-addon.png',
    favicon: '/brand/logos/favicon.png',
  },
};
